export default class Length {
	constructor( millimeters ) {
		this.millimeters = millimeters;
	}

	static from_m( meters ) {
		return new Length( meters * 1000 );
	}

	static from_cm( centimeters ) {
		return new Length( centimeters * 10 );
	}

	static from_mm( millimeters ) {
		return new Length( millimeters );
	}

	in_m() {
		return this.millimeters / 1000;
	}

	in_cm() {
		return this.millimeters / 10;
	}

	in_cm_i18n() {
		const locale = window.measurementSelectorVariables?.shop?.locale.replace( '_', '-' ) || 'nl-NL';
		return this.in_cm().toLocaleString( locale, { minimumFractionDigits: 0, maximumFractionDigits: 1 } );
	}

	in_mm() {
		return this.millimeters;
	}

	add( length ) {
		return new Length( this.in_mm() + length.in_mm() );
	}

	subtract( length ) {
		return new Length( this.in_mm() - length.in_mm() );
	}

	max( length ) {
		return new Length( Math.max( this.in_mm(), length.in_mm() ) );
	}

	min( length ) {
		return new Length( Math.min( this.in_mm(), length.in_mm() ) );
	}

	multiply( int ) {
		return new Length( this.millimeters * int );
	}

	divide( by ) {
		return new Length( this.millimeters / by );
	}

	abs() {
		return new Length( Math.abs( this.millimeters ) );
	}

	round( decimals = 2 ) {
		return new Length( Number( Math.round( this.millimeters + 'e' + decimals ) + 'e-' + decimals ) );
	}

	is_lesser_than( length ) {
		return this.millimeters < length.in_mm();
	}
}
